module.exports = __webpack_public_path__ + "img/loading.7b17d4de.gif";